export const getRingsWithoutDuplicates = rings => {
  return rings
    .map(contour => [...new Set(contour.map(ring => `${ring[0]},${ring[1]}`))])
    .map(contour => contour.map(coords => coords.split(",").map(Number)));
};
